import { AppEventCounter } from "@/constants/app-event-counter-values";

const STATUS_BY_HTTP_CODE = {
    200: AppEventCounter.Statuses.OK,
    400: AppEventCounter.Statuses.BAD_REQUEST,
    404: AppEventCounter.Statuses.NOT_FOUND,
    500: AppEventCounter.Statuses.SERVER_ERROR,
};

export function getAppEventCounterStatus(httpStatusCode) {
    if (httpStatusCode === undefined || httpStatusCode === null || httpStatusCode === "") {
        return AppEventCounter.Statuses.UNKNOWN;
    }

    return STATUS_BY_HTTP_CODE[Number(httpStatusCode)] ?? AppEventCounter.Statuses.UNKNOWN;
}

export function getAppEventCounterStatusFromResponse(response) {
    return getAppEventCounterStatus(response?.status);
}
